import React from 'react';
import RSelect, {components} from 'react-select';

const CustomSelectInput = (props) => {
  var customProps = Object.assign({}, props);
  delete customProps.autoCorrect;
  delete customProps.autoCapitalize;
  return <components.Input {...customProps} />;
};

const Select = ({options, selected, onChange, onBlur, placeholder, disabled}) => {
  return (
    <RSelect
      tabIndex={-1}
      name="form-field-name"
      className="react-select"
      placeholder={placeholder}
      classNamePrefix="react-select"
      value={selected}
      noOptionsMessage={() => 'Nada encontrado'}
      options={options}
      onChange={onChange}
      onBlur={onBlur}
      components={{Input: CustomSelectInput}}
      isDisabled={disabled}
    />
  );
};

export default React.memo(Select);
